<template>
    <div v-if="themeStore.themeIndex === 1">
        <DepositViewOne :data-set="dataSet" @selectChannel="selectChannel" @updateSelecTopup="updateSelecTopup"
            :is-component-use="isComponent" @updateCpfID="updateCpfID" @updateSelectedAmount="updateSelectedAmount"
            @selectAmountCard="selectAmountCard" @confirmDeposit="confirmDeposit" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <DepositViewTwo :data-set="dataSet" @selectChannel="selectChannel" @updateSelecTopup="updateSelecTopup"
            @updateCpfID="updateCpfID" @updateSelectedAmount="updateSelectedAmount" @selectAmountCard="selectAmountCard"
            @confirmDeposit="confirmDeposit" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <DepositViewThree ref="depositViewThreeRef" :data-set="dataSet" @selectChannel="selectChannel"
            @updateSelecTopup="updateSelecTopup" :@updateCpfID="updateCpfID"  :is-component-use="isComponent"
            @updateSelectedAmount="updateSelectedAmount" @selectAmountCard="selectAmountCard"
            @confirmDeposit="confirmDeposit" />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <DepositViewFour ref="depositViewFourRef" :data-set="dataSet" @selectChannel="selectChannel"
            @updateSelecTopup="updateSelecTopup" :@updateCpfID="updateCpfID"  :is-component-use="isComponent"
            @updateSelectedAmount="updateSelectedAmount" @selectAmountCard="selectAmountCard"
            @confirmDeposit="confirmDeposit" />
    </div>
    <QRPopup ref="depositQRRef" v-if="themeStore.themeIndex === 1" />
    <QRPopupTwo ref="depositQRRef" v-if="themeStore.themeIndex === 2" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
    <FirstDepositPopupOne ref="firstDepositRef" v-if="themeStore.themeIndex === 1"
        @check-popup-flow="checkFirstRechargeEligible" />
    <FirstDepositPopupTwo ref="firstDepositRef" v-if="themeStore.themeIndex === 2"
        @check-popup-flow="checkFirstRechargeEligible" />
    <FirstDepositPopupThree ref="firstDepositRef" v-if="themeStore.themeIndex === 3"
        @check-popup-flow="checkFirstRechargeEligible" />
    <FirstDepositPopupFour ref="firstDepositRef" v-if="themeStore.themeIndex === 4"
        @check-popup-flow="checkFirstRechargeEligible" />
    <DailyRechargePopupOne ref="dailyRechargeRef" v-if="themeStore.themeIndex === 1"
        @check-popup-flow="checkFirstRechargeEligible" />
    <DailyRechargePopupTwo ref="dailyRechargeRef" v-if="themeStore.themeIndex === 2"
        @check-popup-flow="checkFirstRechargeEligible" />
    <DailyRechargePopupThree ref="dailyRechargeRef" v-if="themeStore.themeIndex === 3"
        @check-popup-flow="checkFirstRechargeEligible" />
    <DailyRechargePopupFour ref="dailyRechargeRef" v-if="themeStore.themeIndex === 3"
        @check-popup-flow="checkFirstRechargeEligible" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { deposit, getChannels, getErcCode, getFirstRechargeRewardEligible, rechargeConfigurations } from '@/api/deposit';
import { PAYMENT_TYPE } from '@/constants';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import QRPopup from '@/themes/themeOne/deposit/components/QRPopup.vue';
import QRPopupTwo from '@/themes/themeTwo/deposit/components/QRPopup.vue';
import FirstDepositPopupOne from '@/themes/themeOne/deposit/components/firstDepositPopup.vue';
import FirstDepositPopupTwo from '@/themes/themeTwo/deposit/components/firstDepositPopup.vue';
import FirstDepositPopupThree from '@/themes/themeThree/deposit/components/firstDepositPopup.vue';
import FirstDepositPopupFour from '@/themes/themeFour/deposit/components/firstDepositPopup.vue';
import { useUserStore } from '@/stores/user';
import { useRoute, useRouter } from 'vue-router';
import { amountItem, DepositData, PayChannel } from './supportScript'
import DepositViewOne from '@/themes/themeOne/deposit/depositView.vue';
import DepositViewTwo from '@/themes/themeTwo/deposit/depositView.vue';
import DepositViewThree from '@/themes/themeThree/deposit/depositView.vue';
import DepositViewFour from '@/themes/themeFour/deposit/depositView.vue';
import { useThemeStore } from '@/stores/theme';
import DailyRechargePopupOne from '@/themes/themeOne/deposit/components/dailyRechargePopup.vue';
import DailyRechargePopupTwo from '@/themes/themeTwo/deposit/components/dailyRechargePopup.vue';
import { checkDate } from '@/utils/commonFunction';
import DailyRechargePopupThree from '@/themes/themeThree/deposit/components/dailyRechargePopup.vue';
import DailyRechargePopupFour from '@/themes/themeFour/deposit/components/dailyRechargePopup.vue';
const props = defineProps<{
    isComponent?: boolean
}>()
const router = useRouter()
const min_amount = ref(0);
const max_amount = ref(0);
const channelList = ref<PayChannel[]>([])
const activeChannel = ref<PayChannel>({
    id: 0,
    name: '',
    channelType: '',
    rechargeNotice: '',
    chainType: '',
})
const route = useRoute()
const userStore = useUserStore()
const themeStore = useThemeStore()
const rechargePopupShowStatus: any = computed(() => userStore.acceptFirstRechargeBonus) // 0 - both disable, 1 - both enable 
const amountList = ref<amountItem[]>([])
const selectedAmount = ref<number | string>('')
const selectedItem = ref<any>({})
const isFillField = ref(false)
const selecTopup = ref(false)
const turnOverValue = ref(1)
const giftAmount = ref(0)
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const loadingRef = ref()
const depositQRRef = ref()
const cpfID = ref('')
const showCPFIdError = ref(false)
const firstDepositRef = ref()
const dailyRechargeRef = ref()
const isFirstRechargeRewardEligible = computed(() => userStore.isFirstRechargeRewardEligible)
const isBargainEligible = ref(0)
const configId = ref<any>('')
const treasureType = ref<any>('')
const batchRechargeLogId = ref('')
const ercCode = ref('')
const minErcAmount = ref('')
const maxErcAmount = ref('')
const rechargeNotice = ref('')
const depositViewThreeRef = ref()
const depositViewFourRef = ref()
const dataSet = computed<DepositData>(() => ({
    channelList: channelList.value,
    turnOverValue: turnOverValue.value,
    activeChannel: activeChannel.value,
    showCPFIdError: showCPFIdError.value,
    selectedAmount: selectedAmount.value,
    selecTopup: selecTopup.value,
    giftAmount: giftAmount.value,
    isFillField: isFillField.value,
    isSuccess: isSuccess.value,
    toastContent: toastContent.value,
    cpfID: cpfID.value,
    min_amount: min_amount.value,
    max_amount: max_amount.value,
    amountList: amountList.value,
    ercCode: ercCode.value,
    minErcAmount: minErcAmount.value,
    maxErcAmount: maxErcAmount.value,
    rechargeNotice: rechargeNotice.value
}))

const updateSelecTopup = (val: boolean) => {
    selecTopup.value = val
}
const updateSelectedAmount = (val: number) => {
    selectedAmount.value = val
}
const updateCpfID = (val: string) => {
    cpfID.value = val
}
const selectChannel = (item: PayChannel) => {
    activeChannel.value = item;
    if (item.chainType == 1 || item.chainType == 2 || item.chainType == 3) {
        let params = {
            uid: userStore.id,
            channelType: item.chainType
        }
        getERCData(params)
    }
}

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    selectedItem.value = select
    calculateTurnOver(select)
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const calculateTurnOver = (item: any) => {
    if (selecTopup.value) {
        if (selectedItem.value) {
            giftAmount.value = (item.fillValue * item.giftRatio) / 100;
            let turnOver = item.codingRequirement / (Number(selectedAmount.value) + giftAmount.value);
            turnOverValue.value = parseInt(turnOver.toString(), 10);
        } else {
            if (selectedAmount.value == '' || selectedAmount.value == 0) {
                turnOverValue.value = 1;
                giftAmount.value = 0;
            } else {
                for (let i = amountList.value.length - 1; i >= 0; i--) {
                    let selectValue = Number(amountList.value[i].fillValue);
                    if (Number(selectedAmount.value) > selectValue) {
                        let selectData = amountList.value[i]
                        giftAmount.value = (selectData.fillValue * selectData.giftRatio) / 100;
                        let turnOver = selectData.codingRequirement / (Number(selectedAmount.value) + giftAmount.value);
                        turnOverValue.value = parseInt(turnOver.toString(), 10);
                        break;
                    } else {
                        let selectData = amountList.value[0]
                        giftAmount.value = 0
                        let turnOver = 1
                        turnOverValue.value = parseInt(turnOver.toString(), 10);
                    }
                }
            }

        }
    }
}
const getChannelList = () => {
    getChannels({ paymentType: PAYMENT_TYPE.DEPOSIT }).then(res => {
        channelList.value = res.data;
        activeChannel.value = channelList.value[0] || { id: 0, name: '' };
        selectChannel(activeChannel.value)
    }).catch(err => {
        if (err.code != 401) {
            showError(err)
        }
    });
}
const getERCData = (params: any) => {
    getErcCode(params).then(res => {
        ercCode.value = res.data.walletAddress || ''
        minErcAmount.value = res.data.minAmount
        maxErcAmount.value = res.data.maxAmount
    }).catch(err => {
        if (err.code != 401) {
            showError(err)
        }
    });
}
const confirmDeposit = () => {
    loadingRef.value.open()
    let params = {
        paymentChannelId: activeChannel.value.id,
        coin: selectedAmount.value,
        rechargeType: selecTopup.value ? "2" : "1",
        cpf_id: cpfID.value,
        extra: giftAmount.value,
        times: turnOverValue.value,
        isGiftEligible: isFirstRechargeRewardEligible.value ? 1 : 0,
        isBargainEligible: isBargainEligible.value,
        activityLogId: configId.value,
        activityType: treasureType.value,
        batchRechargeLogId: batchRechargeLogId.value,
        rechargeBonusType: userStore.rechargeBonusType
    }
    if (activeChannel.value.channelType == '7' || activeChannel.value.channelType == '2') {
        params.cpf_id = cpfID.value
    }
    deposit(params).then(res => {
        loadingRef.value.close()
        if (themeStore.themeIndex === 3) {
            depositViewThreeRef.value?.triggerConfirm(res.data.url)
        } else if (themeStore.themeIndex === 4) {
            depositViewFourRef.value?.triggerConfirm(res.data.url)
        }
        else {
            depositQRRef.value.open(res.data.url)
        }
        if (treasureType.value || batchRechargeLogId.value) {
            userStore.getInfo()
        }
        if (route.query.type) {
            clearQueryParams()
        }
        checkFirstRechargeEligible()
        selectedAmount.value = ''

    }).catch(err => {
        loadingRef.value.close()
        showError(err)
    });
}

const getRechargeConfigValue = () => {
    loadingRef.value.open()
    const data = {
        type: selecTopup.value ? "2" : "1",
    }
    rechargeConfigurations(data).then(res => {
        loadingRef.value.close()
        amountList.value = res.data
        min_amount.value = res.data[0].fillValue;
        max_amount.value = res.data.at(-1).fillValue;
        if (route.query.value) {
            isBargainEligible.value = 1
            selectedAmount.value = Number(route.query.value)
            calculateTurnOver(selectedAmount.value)
        }
        if (route.query.firstRechargeValue) {
            selectedAmount.value = Number(route.query.firstRechargeValue)
            calculateTurnOver(selectedAmount.value)
        }
        if (userStore.firstRechargeAmount) {
            selectedAmount.value = userStore.firstRechargeAmount
            calculateTurnOver(selectedAmount.value)
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close()
            showError(err)
        }
    });
}

const checkFirstRechargeEligible = () => {
    loadingRef.value.open()
    getFirstRechargeRewardEligible().then(res => {
        loadingRef.value.close()
        if (res.data) {
            if (userStore.rechargeBonusType == 0) {
                if (res.data?.firstRechargeEligible) {
                    if (rechargePopupShowStatus.value == 1 || rechargePopupShowStatus.value == 3) { //3 - daily disable, first enable
                        userStore.setisFirstRechargeRewardEligible(res.data?.firstRechargeEligible || false)
                        const ignoreFirstRechargeDate = localStorage.getItem('ignoreDate') || ''
                        if (ignoreFirstRechargeDate) {
                            if (checkDate(ignoreFirstRechargeDate) != 0) {
                                firstDepositRef.value.open()
                                return
                            }
                        } else {
                            firstDepositRef.value.open()
                            return
                        }

                    }
                }
                if (res.data?.dailyFirstEligible) {
                    if (rechargePopupShowStatus.value == 1 || rechargePopupShowStatus.value == 2) { // 2- first disable, dailyenable
                        const ignoreDailyRechargeDate = localStorage.getItem('ignoreDate_daily') || ''
                        if (ignoreDailyRechargeDate) {
                            if (checkDate(ignoreDailyRechargeDate) != 0) {
                                dailyRechargeRef.value.open()
                            }
                        } else {
                            dailyRechargeRef.value.open()
                        }
                    }
                }
            }
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close()
            showError(err)
        }
    });
}
const clearQueryParams = () => {
    router.replace({ query: {} });
    configId.value = ''
    treasureType.value = ''
}
watch(() => selectedAmount.value, (newVal) => {
    if (Number(newVal) > max_amount.value) {
        selectedAmount.value = max_amount.value;
    } else {
        selectedAmount.value = newVal;
    }
    let selected = amountList.value.find(
        (item) => Number(item.fillValue) == newVal
    );
    selectedItem.value = selected;
    calculateTurnOver(selected);
    isFillField.value = Number(newVal) < min_amount.value;

    if (newVal) {
        if (Number(newVal) < min_amount.value) {
            isFillField.value = false
        } else if (Number(newVal) > max_amount.value) {
            isFillField.value = false
        } else {
            isFillField.value = true
        }
    } else {
        isFillField.value = false
    }

})
watch(() => selecTopup.value, (newVal) => {
    getRechargeConfigValue()
    selectedAmount.value = ''

})
watch(cpfID, (val) => {
    if (val.length == 11 || val.length == 0) {
        showCPFIdError.value = false
        isFillField.value = true
    } else {
        showCPFIdError.value = true
        isFillField.value = false
    }
})

const resetData = () => {
    getChannelList()
    getRechargeConfigValue()
    checkFirstRechargeEligible()

    setTimeout(() => {
        if (route.query.value) {
            isBargainEligible.value = 1
            selectedAmount.value = Number(route.query.value) || ''
        }
        if (route.query.type) {
            configId.value = Number(route.query.cId) || Number(route.query.mode) || ''
            treasureType.value = Number(route.query.type)
        }
        if (route.query.batchRecharge) {
            batchRechargeLogId.value = userStore.pendingBackendRecharge?.id
        }
        if (route.query.firstRechargeValue) {
            selectedAmount.value = Number(route.query.firstRechargeValue) || ''
        }
    }, 2000)

}
defineExpose({
    resetData
})
onMounted(() => {
    resetData()
    console.log('iscomponent', props.isComponent);

})


</script>
